export default __webpack_public_path__ + "static/media/TodoApp.ec91d1e5.gif";